import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import classes from './header.module.css';
import Logo from '../../../assets/images/logo.png';
import Profile from '../../../assets/images/profile.png';
import ProfileMenu from './profileMenu/profileMenu';
import { connect } from 'react-redux';
import { changeLanguage } from "../../../store/actions/index";

const Header = (props) => {
  const location = useLocation();
  let navigationLinks = [
    {
      "id": 1,
      "name_en": "HOME",
      "name_ar": "الرئيسية",
      "slug": "",
      "type": "static",
      "value": "/",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 2,
      "name_en": "WHAT'S NEW",
      "name_ar": "جديدنا",
      "slug": "whats-new",
      "type": "static",
      "value": "/whats-new",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 3,
      "name_en": "ABOUT US",
      "name_ar": "من نحن",
      "slug": "about-us",
      "type": "static",
      "value": "/about-us",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 4,
      "name_en": "ACADEMY",
      "name_ar": "الأكاديمية",
      "slug": "academy",
      "type": "static",
      "value": "/academy",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 5,
      "name_en": "CAMPS",
      "name_ar": "المخيمات",
      "slug": "camps",
      "type": "static",
      "value": null,
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": [
        {
          "id": 51,
          "name_en": "SUMMER CAMP",
          "name_ar": "المخيم الصيفي",
          "slug": "camps/summer-camp",
          "type": "static",
          "value": "/camps/summer-camp",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        },
        {
          "id": 52,
          "name_en": "WINTER CAMP",
          "name_ar": "المخيم الشتوي",
          "slug": "camps/winter-camp",
          "type": "static",
          "value": "/camps/winter-camp",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        },
        {
          "id": 53,
          "name_en": "FOOTBALL CAMP",
          "name_ar": "مخيم كرة القدم",
          "slug": "camps/football-camp",
          "type": "static",
          "value": "/camps/football-camp",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        }
      ]
    },
    {
      "id": 6,
      "name_en": "ACTIVITIES",
      "name_ar": "النشاطات",
      "slug": "activities",
      "type": "static",
      "value": null,
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": [
        {
          "id": 61,
          "name_en": "BIRTHDAYS",
          "name_ar": "أعياد الميلاد",
          "slug": "activities/birthdays",
          "type": "static",
          "value": "/activities/birthdays",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        },
        {
          "id": 62,
          "name_en": "TEAM BUILDING",
          "name_ar": "بناء الفريق",
          "slug": "activities/team-building",
          "type": "static",
          "value": "/activities/team-building",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        },
        {
          "id": 63,
          "name_en": "EVENTS",
          "name_ar": "الأحداث",
          "slug": "activities/events",
          "type": "static",
          "value": "/activities/events",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        }
      ]
    },
    {
      "id": 7,
      "name_en": "TOURNAMENTS",
      "name_ar": "البطولات",
      "slug": "tournaments",
      "type": "static",
      "value": "/tournaments",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 8,
      "name_en": "CONTACT US",
      "name_ar": "اتصل بنا",
      "slug": "contact-us",
      "type": "static",
      "value": "/contact-us",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 9,
      "name_en": "FRANCHISE",
      "name_ar": "امتياز",
      "slug": "franchise",
      "type": "static",
      "value": "/franchise",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    /*{
      "id": 10,
      "name_en": "ETIHAD CLUB",
      "name_ar": "نادي الاتحاد",
      "slug": "etihad-club",
      "type": "static",
      "value": "#",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 11,
      "name_en": "KIDS AREA",
      "name_ar": "نادي الأطفال",
      "slug": "kids-area",
      "type": "static",
      "value": "#",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },*/
  ]
  let languageList = [
    {
      'id': 1,
      'display_value': 'EN',
      'name': parseInt(localStorage.getItem('language')) === 1 ? 'English' : 'انجليزي',
      'dir': 'ltr',
      'lang': 'en'
    },
    {
      'id': 0,
      'display_value': 'عربي',
      'name': parseInt(localStorage.getItem('language')) === 1 ? 'Arabic' : 'عربي',
      'dir': 'rtl',
      'lang': 'ar'
    }
  ]
  const [subMenuOpen, setSubMenuOpen] = useState(null);
  const [languageMenuOpen, setLanguageMenuOpen] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(languageList.filter((item) => item.id === parseInt(localStorage.getItem('language')))[0]);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [profileImg, setProfileImg] = useState(Profile);

  const subMenuRef = useRef(null);
  const languageMenuRef = useRef(null);

  useEffect(() => {
    setProfileImg(props.userData?.basic_info?.avatar ? props.userData?.basic_info?.avatar : Profile);
    handleLanguageSwitch(selectedLanguage);
    const handleClickOutside = (event) => {
      if (subMenuRef.current && !subMenuRef.current.contains(event.target)) {
        setSubMenuOpen(null);
      }
      if (languageMenuRef.current && !languageMenuRef.current.contains(event.target)) {
        setLanguageMenuOpen(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    setProfileImg(props.userData?.basic_info?.avatar ? props.userData?.basic_info?.avatar : Profile);
  }, [props.userData]);
  const handleLanguageSwitch = (lang) => {
    setSelectedLanguage(lang);
    props.onLanguageChange(lang.id);
    document.documentElement.dir = lang.dir;   // Change the direction of the app (LTR or RTL)
    document.documentElement.lang = lang.lang; // Change the lang attribute of the app (en or ar)
    setLanguageMenuOpen(false); // Close the language menu after selection
  };
  const handleMenuClick = (slug) => {
    setLanguageMenuOpen(false)
    setSubMenuOpen(subMenuOpen === slug ? null : slug);
  };
  const handleLanguageMenuClick = () => {
    setSubMenuOpen(false);
    setLanguageMenuOpen(!languageMenuOpen);
  };

  // Add translations
  const translations = {
    login: {
      en: 'LOGIN',
      ar: 'تسجيل الدخول'
    }
  };

  return (
    <div className={classes.Container}>
      <div className={classes.Header}>
        <NavLink to='/' className={classes.Logo}>
          <img src={Logo} alt='6 Yard logo' />
        </NavLink>
        <nav className={classes.NavigationLinks}>
          {navigationLinks.map((link) => {
            const isChildActive = link.children.some(child => location.pathname === child.value);
            if (link.value) return (
              <NavLink
                key={link.id}
                to={link.value}
                className={({ isActive }) => (isActive && link.value ? classes.Active : '')}
              >
                {parseInt(localStorage.getItem('language')) === 1 ? link.name_en : link.name_ar}
              </NavLink>
            );
            else
              return (
                <div
                  key={link.id}
                  className={`${classes.TabWithSubMenu} ${subMenuOpen === link.slug ? classes.Active : isChildActive ? classes.WithChildActive : ''}`}
                  onClick={() => handleMenuClick(link.slug)}
                  ref={subMenuOpen === link.slug ? subMenuRef : null}
                >
                  <span>
                    {parseInt(localStorage.getItem('language')) === 1 ? link.name_en : link.name_ar} 
                    <span className={classes.ArrowDown}></span>
                  </span>
                  {subMenuOpen === link.slug && (
                    <div className={classes.SubMenuDropdown}>
                      <ul>
                        {link.children.map((child) => (
                          <li key={child.id}>
                            <NavLink
                              to={child.value}
                              className={({ isActive }) => (isActive && child.value ? classes.Active : '')}
                            >
                              {parseInt(localStorage.getItem('language')) === 1 ? child.name_en : child.name_ar}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              );
          })}
        </nav>
        <div className={classes.RightMenu}>
          <span className={classes.Border} />
          <div
            className={`${classes.LanguageMenu} ${languageMenuOpen && classes.LanguageMenuOpened}`}
            onClick={() => handleLanguageMenuClick()}
            ref={languageMenuRef}
          >
            <span>
              {selectedLanguage.display_value ? selectedLanguage.display_value : 'EN'} 
              <span className={classes.ArrowDown}></span>
            </span>
            {languageMenuOpen && (
              <div className={classes.SubMenuDropdown}>
                <ul>
                  {languageList.map((lang) => (
                    <li key={lang.id} onClick={() => handleLanguageSwitch(lang)}>
                      {lang.name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          {props.isAuthenticated ? (
            <div className={classes.ProfileContainer} onClick={() => setShowProfileMenu(true)}>
              <img
                src={profileImg} 
                alt="Profile"
              />
            </div>
          ) : (
            <NavLink className={classes.LoginButton} to='/login'>
              {parseInt(localStorage.getItem('language')) === 1 ? translations.login.en : translations.login.ar}
            </NavLink>
          )}
        </div>
        {showProfileMenu && <ProfileMenu showProfileMenu
          setShowProfileMenu={() => setShowProfileMenu()}
          onLogout={() => props.onLogout()}
          width={props.width}
          user={props.userData}
          navigate={props.navigate}
        />}
      </div>
    </div>
  )
}
const mapStateToProps = state => ({
  selectedLanguage: state.home.selected_language,
  user: state.auth.user
});
const mapDispatchToProps = dispatch => {
  return {
    onLanguageChange: (id) => dispatch(changeLanguage(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);